<div class="container" *ngIf="value">
    <div class="bar">
        <div class="baractions">
            <actions *ngIf="!readonly" [actionstrip]="actions" (clickAction)="onClickAction($event)"></actions>
        </div>
    </div>
    <shared-route-item-log-maintenance [phase]="value.phase"></shared-route-item-log-maintenance>
   
</div>